module.exports = __webpack_public_path__ + "img/__icon_JOLODA.af8f6db7.svg";